import {
    GET_FUEL_VENDOR_ACCOUNT,
    GET_FUEL_VENDOR_NAMES,
    TOGGLE_FUEL_VENDOR_NAMES_LOADED,
    UPDATE_FUEL_VENDOR_ACCOUNT,
    TOGGLE_DUPLICATE_FUEL_VENDOR,
    UPDATE_CREATED_FUEL_ID,
    TOGGLE_FUEL_DETAILS_LOADED,
    TOGGLE_FUEL_SPINNER,
    TOGGLE_SUMMARY_SPINNER,
    DISCARD_FUEL_CHANGES,
    DISABLE_INTERACTIVE_FIELD,
    DISABLE_SAVE_BUTTON,
    CLOSE_SNACKBAR,
    GET_FUEL_VENDOR_ACCOUNTS,
    SET_SORT_ORDER,
    SET_SORT_FIELD,
    CLEAR_FUEL_VENDOR,
    DELETE_FUEL_VENDOR_ACCOUNT,
    RESET_FUEL_VENDOR_ACCOUNT,
    TOGGLE_EDIT_DETAILS,
    SET_PREVIOUS_SELECTED_FUEL_ACCOUNTS,
    SET_SELECTED_FUEL_ACCOUNTS,
    RESET_PAGE_SIZE,
    UNSET_PREVIOUS_SELECTED_FUEL_ACCOUNTS
} from './types';
import { SHOW_DANGER_BAR, SHOW_SUCCESS_BAR } from 'store/actions/types';
import * as Constants from 'constants/Constants';
import axios from 'axios';

export const getFuelVendorAccount = (id) => {
    const URL = `https://${Constants.FUEL_VENDOR_ENDPOINT}/api/v1/fuelvendor/configurations/${id}`;

    return (dispatch, getState) => {
        dispatch({
            type: TOGGLE_FUEL_SPINNER,
            payload: true
        });
        const { sessionValue } = getState().session;
        const params = {
            accountId: sessionValue.isCarrier
                ? sessionValue.accountId
                : sessionValue.selected_accountId
        };
        axios
            .get(URL, { params })
            .then((response) => {
                dispatch({
                    type: GET_FUEL_VENDOR_ACCOUNT,
                    payload: response.data
                });
            })
            .catch((error) => {
                if (error.response.status !== 401) {
                    const message = 'Error while fetching Fuel Card Partners Details';
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: message
                    });
                }
            })
            .finally(() => {
                dispatch({
                    type: TOGGLE_FUEL_SPINNER,
                    payload: false
                });
            });
    };
};

export const deleteFuelVendorAccounts = (ids) => {
    return (dispatch, getState) => {
        dispatch({
            type: TOGGLE_SUMMARY_SPINNER,
            payload: true
        });
        const URL = `https://${Constants.FUEL_VENDOR_ENDPOINT}/api/v1/fuelvendor/configurations`;
        const { sessionValue } = getState().session;
        const accountId = sessionValue.accountId;
        const params = {
            accountId: accountId
        };
        const headers = {
            creator_id: sessionValue.userId
        };
        axios
            .delete(URL, { headers, params, data: ids })
            .then((response) => {
                dispatch({
                    type: DELETE_FUEL_VENDOR_ACCOUNT,
                    payload: response.data
                });
                dispatch(getFuelVendorAccounts());
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Selected account(s) deleted successfully'
                });
            })
            .catch((error) => {
                const message = 'Failed to delete the selected account(s).';
                dispatch({
                    type: SHOW_DANGER_BAR,
                    payload: message
                });
                dispatch({
                    type: TOGGLE_SUMMARY_SPINNER,
                    payload: false
                });
            });
    };
};

export const clearFuelVendorAccounts = () => {
    return {
        type: CLEAR_FUEL_VENDOR,
        payload: []
    };
};

export const getFuelVendorAccounts = (page, size, order, field, query) => {
    return (dispatch, getState) => {
        dispatch({
            type: TOGGLE_SUMMARY_SPINNER,
            payload: true
        });
        const { sessionValue } = getState().session;
        const URL = `https://${Constants.FUEL_VENDOR_ENDPOINT}/api/v1/fuelvendor/configurations/q?`;
        const accountId = sessionValue.accountId;
        const params = {
            page,
            size,
            order,
            field,
            query,
            accountId: sessionValue.isCarrier ? accountId : sessionValue.selected_accountId
        };
        dispatch(clearFuelVendorAccounts());
        axios
            .get(URL, { params })
            .then((response) => {
                dispatch({
                    type: GET_FUEL_VENDOR_ACCOUNTS,
                    payload: response.data
                });
                dispatch(setSelectedFuelAccounts([]));
            })
            .catch((error) => {
                if (error.response.status !== 401) {
                    const message = 'Error while fetching Fuel-vendor accounts';
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: message
                    });
                }
            })
            .finally(() => {
                dispatch({
                    type: TOGGLE_SUMMARY_SPINNER,
                    payload: false
                });
            });
    };
};

export const setSortOrder = (value) => (dispatch) => {
    dispatch({
        type: SET_SORT_ORDER,
        payload: value
    });
};

export const setSortField = (value) => (dispatch) => {
    dispatch({
        type: SET_SORT_FIELD,
        payload: value
    });
};

export const closeSnackBar = () => {
    return {
        type: CLOSE_SNACKBAR,
        payload: false
    };
};

export const getVendorNames = () => {
    const URL = `https://${Constants.FUEL_VENDOR_ENDPOINT}/api/v1/fuelvendor/vendors`;

    return (dispatch, getState) => {
        dispatch({
            type: TOGGLE_FUEL_VENDOR_NAMES_LOADED,
            payload: false
        });
        const { sessionValue } = getState().session;
        const params = {
            accountId: sessionValue.accountId
        };
        axios
            .get(URL, { params })
            .then((response) => {
                dispatch({
                    type: GET_FUEL_VENDOR_NAMES,
                    payload: response.data
                });
                dispatch({
                    type: TOGGLE_FUEL_VENDOR_NAMES_LOADED,
                    payload: true
                });
            })
            .catch((error) => {
                if (error.response.status !== 401) {
                    const message = 'Error while fetching Fuel Card Partners Names';
                    dispatch({
                        type: SHOW_DANGER_BAR,
                        payload: message
                    });
                }
            });
    };
};

export const updateFuelAccount = (account) => {
    return (dispatch) => {
        dispatch({
            type: UPDATE_FUEL_VENDOR_ACCOUNT,
            payload: account
        });
    };
};

export const saveFuelVendor = (fuelaccount) => {
    return (dispatch, getState) => {
        const URL = `https://${Constants.FUEL_VENDOR_ENDPOINT}/api/v1/fuelvendor/configurations`;
        const { sessionValue } = getState().session;
        const params = {
            accountId: sessionValue.accountId
        };
        const headers = {
            creator_id: sessionValue.userId
        };

        dispatch({
            type: TOGGLE_FUEL_SPINNER,
            payload: true
        });

        axios
            .post(URL, fuelaccount, {
                headers,
                params
            })
            .then((response) => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Fuel card partner created successfully'
                });
                const id = response.data.id;
                dispatch({
                    type: UPDATE_CREATED_FUEL_ID,
                    payload: id
                });
                dispatch(getFuelVendorAccount(id));
            })
            .catch((error) => {
                dispatch({
                    type: SHOW_DANGER_BAR,
                    payload: 'Failed to create the fuel card partner'
                });
                if (
                    error.response.data.errorCode === 'FV-400' &&
                    error.response.data.errorDescription === Constants.FUEL_DUPLICATE_ERROR
                ) {
                    dispatch({
                        type: TOGGLE_DUPLICATE_FUEL_VENDOR,
                        payload: true
                    });
                }
                dispatch({
                    type: TOGGLE_FUEL_SPINNER,
                    payload: false
                });
            });
    };
};

export const updateFuelVendor = (fuelaccount) => {
    return (dispatch, getState) => {
        const URL = `https://${Constants.FUEL_VENDOR_ENDPOINT}/api/v1/fuelvendor/configurations/${fuelaccount.id}`;
        const { sessionValue } = getState().session;
        const params = {
            accountId: sessionValue.accountId
        };
        const headers = {
            creator_id: sessionValue.userId
        };

        dispatch({
            type: TOGGLE_FUEL_SPINNER,
            payload: true
        });

        axios
            .put(URL, fuelaccount, {
                headers,
                params
            })
            .then((response) => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: 'Fuel card partner updated successfully'
                });
                const id = response.data.id;
                dispatch({
                    type: UPDATE_CREATED_FUEL_ID,
                    payload: id
                });
                dispatch(getFuelVendorAccount(id));
            })
            .catch((error) => {
                dispatch({
                    type: SHOW_DANGER_BAR,
                    payload: 'Failed to update the Fuel card partner'
                });
                if (
                    error.response.data.errorCode === 'FV-400' &&
                    error.response.data.errorDescription === Constants.FUEL_DUPLICATE_ERROR
                ) {
                    dispatch({
                        type: TOGGLE_DUPLICATE_FUEL_VENDOR,
                        payload: true
                    });
                }
            })
            .finally(() => {
                dispatch({
                    type: TOGGLE_FUEL_SPINNER,
                    payload: false
                });
            });
    };
};

export const toggleFuelVendorStatus = (vendorsList, flag, isFromSummaryPage = false) => {
    return (dispatch, getState) => {
        dispatch({
            type: isFromSummaryPage ? TOGGLE_SUMMARY_SPINNER : TOGGLE_FUEL_SPINNER,
            payload: true
        });

        const URL = `https://${Constants.FUEL_VENDOR_ENDPOINT}/api/v1/fuelvendor/configurations/status`;
        const { sessionValue } = getState().session;

        const params = {
            status: flag,
            accountId: sessionValue.accountId
        };
        const headers = {
            creator_id: sessionValue.userId
        };
        axios
            .patch(URL, vendorsList, {
                headers,
                params
            })
            .then((response) => {
                dispatch({
                    type: SHOW_SUCCESS_BAR,
                    payload: flag
                        ? 'Fuel account(s) activated successfully'
                        : 'Fuel account(s) deactivated successfully'
                });
                const id = response.data[0].id;
                if (!isFromSummaryPage) {
                    dispatch(getFuelVendorAccount(id));
                }
            })
            .catch((error) => {
                dispatch({
                    type: SHOW_DANGER_BAR,
                    payload: flag
                        ? 'Failed to activate the selected Fuel account(s)'
                        : 'Failed to deactivate the selected Fuel account(s)'
                });
            })
            .finally(() => {
                if (!isFromSummaryPage) {
                    dispatch({
                        type: TOGGLE_FUEL_SPINNER,
                        payload: false
                    });
                } else {
                    dispatch(getFuelVendorAccounts());
                }
            });
    };
};

export const toggleDuplicateCheck = (flag) => {
    return (dispatch) => {
        dispatch({
            type: TOGGLE_DUPLICATE_FUEL_VENDOR,
            payload: flag
        });
    };
};

export const updateCreatedFuelVendorId = (id) => {
    return (dispatch) => {
        dispatch({
            type: UPDATE_CREATED_FUEL_ID,
            payload: id
        });
    };
};

export const toggleFuelDetailsLoaded = (flag) => {
    return (dispatch) => {
        dispatch({
            type: TOGGLE_FUEL_DETAILS_LOADED,
            payload: flag
        });
    };
};

export const toggleSpinner = (flag) => {
    return (dispatch) => {
        dispatch({
            type: TOGGLE_FUEL_SPINNER,
            payload: flag
        });
    };
};

export const discardFuelChanges = (flag) => {
    return (dispatch) => {
        dispatch({
            type: DISCARD_FUEL_CHANGES,
            payload: flag
        });
    };
};

export const disableInteractField = (flag) => {
    return (dispatch) => {
        dispatch({
            type: DISABLE_INTERACTIVE_FIELD,
            payload: flag
        });
    };
};

export const toggleSaveButton = (flag) => {
    return (dispatch) => {
        dispatch({
            type: DISABLE_SAVE_BUTTON,
            payload: flag
        });
    };
};

export const resetFuelVendorAccount = (account) => {
    return (dispatch) => {
        dispatch({
            type: RESET_FUEL_VENDOR_ACCOUNT,
            payload: account
        });
    };
};

export const toggleEditDetails = (flag) => {
    return (dispatch) => {
        dispatch({
            type: TOGGLE_EDIT_DETAILS,
            payload: flag
        });
    };
};

export const setSelectedFuelAccounts = (selectedFuelAccounts) => (dispatch) => {
    dispatch({
        type: SET_SELECTED_FUEL_ACCOUNTS,
        payload: selectedFuelAccounts
    });
};

export const setPreviousSelectedFuelAccounts = () => {
    return {
        type: SET_PREVIOUS_SELECTED_FUEL_ACCOUNTS
    };
};

export const unSetPreviousSelectedFuelAccounts = (accountIds, flag) => {
    return {
        type: UNSET_PREVIOUS_SELECTED_FUEL_ACCOUNTS,
        payload: accountIds,
        flag
    };
};

export const resetPageAndSize = () => {
    return {
        type: RESET_PAGE_SIZE
    };
};
